exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-document-gallery .modal-dialog{max-width:70vw;text-align:center}#customer-show-document-gallery .modal-title{display:none}#customer-show-document-gallery .modal-content{background:none!important}#customer-show-document-gallery .close{color:#fff}#customer-show-document-gallery .customer-show-document-gallery__title{color:#fff;text-align:left}#customer-show-document-gallery .customer-show-document-gallery__link{color:#fff;font-size:30px;margin-left:30px}#customer-show-document-gallery .customer-show-document-gallery__image{width:100%;margin:0 auto;-o-object-fit:contain;object-fit:contain}", ""]);

// exports
